export const OPERATIONS_COLORS = {
  onTimePercent: "#C6C1A4",
  avgTime: "#9A94D6",
  total: "#826BFF",
  inProgress: "#9B90DA",
  resolved: "#CAC19F",
  pending: "#D4D4D4",
  housekeeping: "#CAC19F",
  maintenance: "#9B90DA",
  concierge: "#826BFF",
  other: "#D4D4D4",
} as const;

export const OPERATIONS_EXECUTION_SERIES = [
  {
    key: "onTimePercent" as const,
    label: "% on-time",
    color: OPERATIONS_COLORS.onTimePercent,
  },
  {
    key: "avgTime" as const,
    label: "Avg time",
    color: OPERATIONS_COLORS.avgTime,
  },
];

export const OPERATIONS_METRIC_WIDGET_HEIGHT = 504;
export const OPERATIONS_METRIC_CHART_Y_MAX = 50;

export const OPERATIONS_APPROVAL_TIME_Y_MAX = 15;
export const OPERATIONS_APPROVAL_TIME_Y_TICKS = [0, 5, 10, 15] as const;

export const OPERATIONS_APPROVAL_TIME_SERIES = [
  {
    key: "frontdeskApprovalTime" as const,
    label: "Frontdesk Approval time",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_INTERNAL_CHAT_RESPONSE_TIME_Y_MAX = 25;
export const OPERATIONS_INTERNAL_CHAT_RESPONSE_TIME_Y_TICKS = [
  0, 5, 10, 15, 20, 25,
] as const;

export const OPERATIONS_INTERNAL_CHAT_RESPONSE_TIME_SERIES = [
  {
    key: "internalChatResponseTime" as const,
    label: "Internal chat response time",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_FRONTDESK_RESPONSE_TIME_Y_MAX = 25;
export const OPERATIONS_FRONTDESK_RESPONSE_TIME_Y_TICKS = [
  0, 5, 10, 15, 20, 25,
] as const;

export const OPERATIONS_FRONTDESK_RESPONSE_TIME_SERIES = [
  {
    key: "frontdeskResponseTime" as const,
    label: "Frontdesk response time",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_AVG_CONVERSATION_DURATION_Y_MAX = 25;
export const OPERATIONS_AVG_CONVERSATION_DURATION_Y_TICKS = [
  0, 5, 10, 15, 20, 25,
] as const;

export const OPERATIONS_AVG_CONVERSATION_DURATION_SERIES = [
  {
    key: "avgConversationDuration" as const,
    label: "Avg. conversation duration",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_CLOSED_CONVERSATIONS_Y_MAX = 100;
export const OPERATIONS_CLOSED_CONVERSATIONS_Y_TICKS = [
  0, 25, 50, 75, 100,
] as const;

export const OPERATIONS_CLOSED_CONVERSATIONS_SERIES = [
  {
    key: "closedConversations" as const,
    label: "Closed conversations",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_ON_HOLD_CANCELED_SERIES = [
  {
    key: "canceledRequests" as const,
    label: "Canceled requests",
    color: OPERATIONS_COLORS.resolved,
  },
  {
    key: "onHoldRequests" as const,
    label: "On hold requests",
    color: OPERATIONS_COLORS.inProgress,
  },
];

export const OPERATIONS_COMPLAINTS_SERIES = [
  {
    key: "complaintCount" as const,
    label: "Complaints",
    color: OPERATIONS_COLORS.pending,
  },
];

export const OPERATIONS_CATEGORY_COLORS = {
  roomServices: "#CAC19F",
  guestServices: "#9B90DA",
  externalServices: "#826BFF",
} as const;

export const OPERATIONS_TOTAL_REQUESTS_TREND_SERIES = [
  {
    key: "guestServices" as const,
    label: "Guest services",
    color: OPERATIONS_CATEGORY_COLORS.guestServices,
  },
  {
    key: "roomServices" as const,
    label: "Room services",
    color: OPERATIONS_CATEGORY_COLORS.roomServices,
  },
  {
    key: "externalServices" as const,
    label: "External services",
    color: OPERATIONS_CATEGORY_COLORS.externalServices,
  },
];
